export const formatCreatedByName = (createdBy) => {
  if (!createdBy) {
    return '';
  }
  const firstName = createdBy.firstName ?? '';
  const lastName = createdBy.lastName ?? '';
  return `${firstName} ${lastName}`.trim();
};

export const formatBedsBathLabel = (numberOfBedrooms, numberOfBathrooms) =>
  `${numberOfBedrooms}/${numberOfBathrooms}`;
